module.exports = __webpack_public_path__ + "img/shop_area_3.d643da48.jpg";